import React, { Fragment, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label, Row } from "reactstrap";
import { AvCheckbox, AvCheckboxGroup, AvForm } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import classNames from "classnames";

import formsValidators, {
  requiredIfOtherExist,
} from "../../validators/form.validators";
import useDropzoneFacade from "../../hooks/useDropzoneFacade";
import useAvForm from "../../hooks/useAvForm";
import FormGroupText from "./inputs/FormGroupText";
import WYSISYGComponent from "./inputs/WYSISYGComponent";
import FormGroupReactSelect from "./inputs/FormGroupReactSelect";
import noop from "../../helpers/noop";
import { getConverterKitTags } from "../../store/dashboard/ConverterKitTags/actions";
import useMountedState from "../../hooks/useMountedState";
import FormGroupVideo from "./inputs/FormGroupVideo";
import InputWithReadOnlyTextPart from "./inputs/InputWithReadOnlyTextPart";
import useInputWithReadOnlyTextPart from "../../hooks/useInputWithReadOnlyTextPart";
import getReadOnlyUrlPart from "../../helpers/getReadOnlyUrlPart";

import styles from "./forms.module.scss";
import { getFileTags } from '../../store/dashboard/FileTags/actions';
import VideoPreview from '../../pages/Dashboard/VideoLibrary/components/VideoPreview';
import VideoWhereUsedInfo from '../../pages/Dashboard/VideoLibrary/components/VideoWhereUsedInfo';
import { removeVideo } from '../../store/dashboard/VideoLibrary/actions';
import { FileTagTypes } from '../../constants/files';


const currencies = ["EUR", "USD", "GBP", "NZD", "AUD", "CAD", "INR"];
const applicableToSubscriptionValue = 'ApplicableToSubscription';
const collaborationCourseValue = 'CollaborationCourse';


const studentLabels = ["Student 1", "Student 2", "Student 3"];

const SaveVideo = ({
  model,
  saveVideoFunc,
  videoLibrary,
  updateDirtyState = noop,
  getFileTags,
  fileTags,
  history,
  removeVideo,
}) => {
  
  const initialState = {
    title: "",
  };

  const [formData, updateFormData] = useState(initialState);
  const [tagId, setTagId] = useMountedState(null);
  const [initialFile, updateInitialFile] = useMountedState(null);
  const [initialVideoThumbnail, updateInitialVideoThumbnail] =
    useMountedState(null);
  const [ready, updateReadyState] = useMountedState(false);
  const [formRef, hasFormError, handleFormChange, isDirty, values] =
    useAvForm();

  const { data: fileTagsData } = fileTags;

  const [error, selectedFiles, handleAcceptedFiles, setSelectedFiles] =
    useDropzoneFacade({ type: "video" });

  const [
    thumbnailError,
    selectedThumbnailImages,
    handleTumbunalAcceptedFiles,
    setSelectedThumbnailImages,
    errorSelectedId,
  ] = useDropzoneFacade();

  const { loading } = videoLibrary;

  const handleFormSubmit = (event, values) => {
    const {
      title,
    } = values;
    const model = {
      title,
    };
    if (initialFile !== selectedFiles[0]) {
      model.files = selectedFiles;
      model.files[0].title = title; // we are adding title to video, for create video
    }

    // if (formData.newVideoTagsForVideo_0 && formData.newVideoTagsForVideo_0.length) {
    //   model.tags = formData.newVideoTagsForVideo_0;
    // }

    for (const fileTagType of Object.values(FileTagTypes)) {
      if (
        formData[`newVideoTagsForVideo_0_${fileTagType}`] &&
        formData[`newVideoTagsForVideo_0_${fileTagType}`].length
      ) {
        model.tags = model.tags || [];
        model.tags = model.tags.concat(
          formData[`newVideoTagsForVideo_0_${fileTagType}`].map((tag) => ({
            name: tag,
            type: fileTagType,
          }))
        );
      }
    }
    

    //Provide support for update, for that we will think
    if (initialVideoThumbnail !== selectedThumbnailImages[0]) {
      model.videoThumbnail = selectedThumbnailImages;
    }

    saveVideoFunc(model);
  };

  const pageTitle = useMemo(
    () => (model ? "Edit video" : "Create video"),
    [model]
  );
  const btnSaveLabel = useMemo(
    () => (model ? "Save" : "Create"),
    [model]
  );
  const disableState = useMemo(
    () =>
      !(
        isDirty ||
        initialFile !== selectedFiles[0] ||
        initialVideoThumbnail !== selectedThumbnailImages[0]
      ) ||
      loading ||
      !selectedFiles.length ||
      !selectedThumbnailImages[0] ||
      hasFormError,
    [
      loading,
      selectedFiles,
      selectedThumbnailImages,
      hasFormError,
      isDirty,
      initialFile,
      initialVideoThumbnail,
      model,
    ]
  );

  useEffect(() => {
    updateDirtyState(isDirty);
  }, [isDirty]);

  useEffect(() => {
    if (!!model) {
      const {
        title,
        initialFile,
      } = model;
      const formData = {
        ...initialState,
        title,
      };

      if (initialFile) {
        updateInitialFile(initialFile);
        handleAcceptedFiles([initialFile], [], undefined, undefined, false);
      }

      if (initialFile?.thumbnailImage) {
        updateInitialVideoThumbnail(initialFile.thumbnailImage);
        handleTumbunalAcceptedFiles([initialFile.thumbnailImage], []);
      }

      updateFormData(formData);
    }

    updateReadyState(true);
  }, [model]);

  useEffect(() => {
    if (ready && selectedFiles.length === 0 && initialFile) {
      setSelectedFiles([initialFile]);
    }
  }, [selectedFiles]);

  useEffect(() => {
    getFileTags();
  }, []);

  const getFileTagOptions = (inputValue) => {
    // if (!inputValue || inputValue.length < 3) {
    //   if (videoLibraryData.length > 0) {
    //     getVideoLibraryForCourseOptionClear();
    //   }
    // }

    if (!!inputValue) {
      getFileTags({ q: inputValue });
    }

  }

  console.log('formData', formData);




  return (
    ready && (
      <>
        <AvForm
          onValidSubmit={handleFormSubmit}
          ref={formRef}
          model={formData}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              return false;
            }
          }}
        >
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{pageTitle}</CardTitle>
              <FormGroupText
                name="title"
                label="Video title"
                placeholder="Enter video title"
                validator={formsValidators.video.title}
                handleFormChange={handleFormChange}
              />
              
              <FormGroupVideo
                disabled={!!model}
                withThumbnail
                withTag
                multiple={false}
                label="Video"
                error={error} // Dropzone
                initialFile={initialFile} // State
                initialVideoThumbnail={initialVideoThumbnail} // State
                updateInitialVideoThumbnail={updateInitialVideoThumbnail} // State
                selectedVideos={selectedFiles} //Dropzone
                handleAcceptedVideos={handleAcceptedFiles} //Dropzone
                setSelectedVideos={setSelectedFiles} //Dropzone
                thumbnailError={thumbnailError} //Dropzone Thumbnail
                selectedThumbnailImages={selectedThumbnailImages} //Dropzone Thumbnail
                handleTumbunalAcceptedFiles={handleTumbunalAcceptedFiles} //Dropzone Thumbnail
                setSelectedThumbnailImages={setSelectedThumbnailImages} //Dropzone Thumbnail
                errorIndex={errorSelectedId} //Dropzone Thumbnail
                updateFormData={updateFormData}
                handleFormChange={handleFormChange}
                fileTagsData={fileTagsData}
                groupIdentifier={'ForVideo'}
                getFileTagOptions={getFileTagOptions}
              />
              {!!model && <Row>
                <Col lg={2}>
                  <CardTitle className="mb-4">Video Preview</CardTitle>
                </Col>
                <Col lg={10}>
                  <VideoPreview video={model} className={styles.videoPreview} />
                </Col>
              </Row>}
              {!!model && <Row className='mt-4'>
                <Col>
                  <CardTitle className="mb-4">Video Info</CardTitle>
                  <VideoWhereUsedInfo video={model} />

                </Col>
              </Row>}

              {/* <FormGroup className='mb-4' row>
              <Col lg={2}>
               <Label>Subscription Preference</Label>
              </Col>
              <Col lg={10}>
              <AvCheckboxGroup className='' name={'applicableToSubscription'}>
                <AvCheckbox
                  onChange={handleFormChange}
                  className="cursor-pointer"
                  customInput
                  label="Applicable to Subscription"
                  value={applicableToSubscriptionValue}
                />
                </AvCheckboxGroup>
              </Col>
              
              </FormGroup> */}
            </CardBody>
          </Card>
          
          <Row className="justify-content-end">
            <Col xs="12">
              <Link
                to={`/video-library`}
              >
                <Button color="secondary" className="mr-2">
                  Cancel
                </Button>
              </Link>
              <Button
                type="submit"
                color="primary"
                disabled={disableState}
                className={classNames(styles.btnSave, 'mr-2')}
              >
                {btnSaveLabel}
              </Button>
              {!!model && <Button
                type="btn"
                color="danger"
                disabled={loading}
                className={styles.btnSave}
                onClick={() => { removeVideo(model.id, history) }}
              >
                Delete
              </Button>}
            </Col>
          </Row>
        </AvForm>
      </>
    )
  );
};

const mapStateToProps = ({ VideoLibrary, FileTags }) => {
  return {
    videoLibrary: VideoLibrary,
    fileTags: FileTags,
  };
};

export default connect(mapStateToProps, { getFileTags, removeVideo })(SaveVideo);
